const variables = {
  colors: {
    base: "#121212",
    neonBlue: "#00fff0",
    neonBlueWhite: "#d7fffd",
    neonRed: "#ff00b0",
    neonRedWhite: "#ffd9f3",
    background: "#001b1b",
    navy: "#142e47",

    blackLight: "#313746",
    gray: "#727d86",
    silver: "#969fa7",
    whitesmoke: "#f1f4f7",
    highlight: "#20a8ea",
    whiteRed: "#ffeaf7",
    secondBlue: "#006969",
    orange: "#ffa22b",
    gradient: "linear-gradient(-45deg,#ffa649,#f7645b,#805ed4)",
  },
  fonts: {
    monospace: "Roboto Mono, monospace",
  },
  sizes: {
    bioWidth: "290px",
    maxWidth: "1100px",
  },
  sideSpace: {
    small: "20px",
    large: "1.5em",
    contentSmall: "20px",
    contentLarge: "2.5em",
  },
  responsive: {
    small: "500px",
    medium: "768px",
    large: "950px",
  },
}

export default variables
